define('i18n-provider',['config-service', 'jquery-i18n'], function() {

  var app = angular.module('i18n.provider', ['config.service']);

  app.provider('i18n', ['configProvider', I18nProvider]);
  app.provider('$i18n', ['configProvider', I18nProvider]);

  function I18nProvider(configProvider) {

    this.dict = configProvider.i18n;

    $.i18n.load(this.dict);

    this.$get = function i18nFactory() {
      $.i18n.__ = $.i18n._
      return $.i18n;
    }

  }

  return app;

});

